import axiosapi from './axios';
import axiosclient from './axios';
import { useCallback } from 'react';
import { AxiosRequestConfig, AxiosResponse } from 'axios';

const useDataHandler = () => {
	const updateData = useCallback( async ({
		className, 
		objectId, 
		updateObject, 
		afterSaveHandler
	}: {
        className: string, 
        objectId: string, 
        updateObject: any, 
        afterSaveHandler?: (objectId: string) => void,
        feedback?: string
    }) => {
		let data : Array<any> = [];
        
		await axiosapi().put(`classes/${className}/${objectId}`,updateObject as AxiosRequestConfig<any> )
			.then((response : AxiosResponse<any, any>) => {
				data = response.data.results;
				if (afterSaveHandler) {
					afterSaveHandler(response.data.objectId);
				}
			})
			.catch(error => {
				console.log(error.message);
			});

		return data;
	}, []);

	const deleteData = useCallback(async ({
		className, 
		objectId, 
		afterSaveHandler
	}: {
        className: string, 
        objectId: string, 
        afterSaveHandler?: (objectId: string) => void,
        feedback?: string
    }) => {
		await axiosclient().delete(`classes/${className}/${objectId}`)
			.then((response : AxiosResponse<any, any>) => {
				if (afterSaveHandler) {
					afterSaveHandler(response.data.objectId);
				}
			})
			.catch(error => {
				console.log(error.message);
			});
	},[]);

	const createData = useCallback(async ({
		className, 
		query, 
		updateObject, 
		afterSaveHandler
	}: {
        className: string, 
        query?: string, 
        updateObject?: any, 
        afterSaveHandler?: (objectId: string) => void,
		message?: {type: string, users: string[]}
        feedback?: string
    }) => {
		const data : Array<any> = [];
		await axiosapi().post(`classes/${className}`, query || updateObject as AxiosRequestConfig<any> )
			.then((response : AxiosResponse<any, any>) => {
				
				if (afterSaveHandler) {
					afterSaveHandler(response.data.objectId);
				}
			})
			.catch(error => {
				console.log(error.message);
			});
		return data;
	}, []);

	return ({
		updateData,
		createData, 
		deleteData
	});
};

export default useDataHandler;